import React from "react";
import Img from "react-image";
import srcIconBiberon from "../../../../../../../styles/img/icon-biberon.svg";

const BiberonImg = () => (
  <Img src={srcIconBiberon} className="img-repas-biberon" />
);

class Biberon extends React.Component {
  constructor(props) {
    super(props);
  }

  handleChange = (event) => {
    let data = { value: event.target.value, name: event.target.value + " ml" };
    this.props.handleChangeBiberon(data);
  };
  render() {
    return (
      <div className="tab-pane active" id="repas-biberon" role="tabpanel">
        <div className="content">
          <div className="d-flex justify-content-between align-items-center container-repas-biberon">
            <BiberonImg />
            <div className="container-select">
              <span>ml</span>
              <input
                type="number"
                name="Biberon"
                className="form-control box-shadow custom-input text-center"
                value={this.props.biberonVolume}
                onChange={this.handleChange}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Biberon;
